import { Maybe, WasteType } from '@iss/libs/graphql';
import { Pipe, PipeTransform } from '@angular/core';

import { DeepPartial } from '@iss/wo-common/types';

@Pipe({ name: 'wasteType', pure: false, standalone: true })
export class WasteTypePipe implements PipeTransform {
  public transform(waste: Maybe<DeepPartial<WasteType>>, type: 'short' | 'long' = 'long'): string {
    return [ waste?.presentedName, type === 'long' ? waste?.ewcCode : undefined ].filter(Boolean).join(' - ');
  }
}
